var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "receipt-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDEEC-Landingpages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Creators",
    transform: "translate(-30.000000, -1829.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 1402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt-24px",
    transform: "translate(0.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,2.21 C20.87,2.21 20.74,2.26 20.65,2.36 L19.86,3.15 C19.66,3.35 19.35,3.35 19.15,3.15 L18.36,2.36 C18.16,2.16 17.85,2.16 17.65,2.36 L16.86,3.15 C16.66,3.35 16.35,3.35 16.15,3.15 L15.36,2.36 C15.16,2.16 14.85,2.16 14.65,2.36 L13.86,3.15 C13.66,3.35 13.35,3.35 13.15,3.15 L12.36,2.36 C12.16,2.16 11.85,2.16 11.65,2.36 L10.86,3.15 C10.66,3.35 10.35,3.35 10.15,3.15 L9.35,2.35 C9.15,2.15 8.84,2.15 8.64,2.35 L7.85,3.15 C7.65,3.35 7.34,3.35 7.14,3.15 L6.35,2.35 C6.15,2.15 5.84,2.15 5.64,2.35 L4.85,3.15 C4.65,3.35 4.34,3.35 4.14,3.15 L3.35,2.35 C3.26,2.26 3.13,2.21 3,2.21 L3,21.8 C3.13,21.8 3.26,21.75 3.35,21.65 L4.14,20.86 C4.34,20.66 4.65,20.66 4.85,20.86 L5.64,21.65 C5.84,21.85 6.15,21.85 6.35,21.65 L7.14,20.86 C7.34,20.66 7.65,20.66 7.85,20.86 L8.64,21.65 C8.84,21.85 9.15,21.85 9.35,21.65 L10.14,20.86 C10.34,20.66 10.65,20.66 10.85,20.86 L11.64,21.65 C11.84,21.85 12.15,21.85 12.35,21.65 L13.14,20.86 C13.34,20.66 13.65,20.66 13.85,20.86 L14.64,21.65 C14.84,21.85 15.15,21.85 15.35,21.65 L16.14,20.86 C16.34,20.66 16.65,20.66 16.85,20.86 L17.64,21.65 C17.84,21.85 18.15,21.85 18.35,21.65 L19.14,20.86 C19.34,20.66 19.65,20.66 19.85,20.86 L20.64,21.65 C20.74,21.75 20.87,21.8 20.99,21.8 L20.99,2.21 L21,2.21 Z M17,17 L7,17 C6.45,17 6,16.55 6,16 C6,15.45 6.45,15 7,15 L17,15 C17.55,15 18,15.45 18,16 C18,16.55 17.55,17 17,17 Z M17,13 L7,13 C6.45,13 6,12.55 6,12 C6,11.45 6.45,11 7,11 L17,11 C17.55,11 18,11.45 18,12 C18,12.55 17.55,13 17,13 Z M17,9 L7,9 C6.45,9 6,8.55 6,8 C6,7.45 6.45,7 7,7 L17,7 C17.55,7 18,7.45 18,8 C18,8.55 17.55,9 17,9 Z",
    id: "Shape",
    fill: "#E8E9EA",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSvg);
export default __webpack_public_path__ + "static/media/TicketSvg.198ce5ea1f840986a8293234750cc213.svg";
export { ForwardRef as ReactComponent };